<template>
  <div class="modalWrap display_center" v-if="tagmodal">
    <div class="modal_body">
      <div class="m_head display_between">
        <span>{{ title }}</span>
        <img src="/image/icon/close.png" @click="closeModal" class="close" />
      </div>
      <div class="m_content">
        <p class="m_text">
          <img
            src="/image/icon/warning.png"
            v-if="type == 'warn'"
            class="tipIcon"
          />
          <img
            src="/image/icon/erro.png"
            v-if="type == 'erro'"
            class="tipIcon"
          />
          <img src="/image/icon/ok.png" v-if="type == 'ok'" class="tipIcon" />
          <span>{{ content }}</span>
        </p>
     
      </div>
         <div class="m_footer"></div>
        <div class="text_right m_btn">
          <span class="btnConfirm" @click="tagmodal = false">确认</span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "msgmodal",
  data() {
    return {
      tagmodal: true,
      title: "",
      content: "",
      type: "",
    };
  },
  methods: {
    closeModal() {
      this.tagmodal = false;
    },
  },
};
</script>

<style scoped>
.m_btn{
    margin: 2%;
}
.modalWrap {
  position: fixed;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
}
.modal_body {
  width: 360px;
  background: #fff;
  border-radius: 5px;
}
.m_head {
  height: 56px;
  box-sizing: border-box;
  border-bottom: 1px solid #ececec;
  padding-left: 20px;
  padding-right: 20px;
}
.m_footer {
  /* height: 30px; */
  box-sizing: border-box;
  border-bottom: 1px solid #ececec;
  padding-left: 20px;
  padding-right: 20px;
}
.m_content {
  padding: 20px;
}
.btnConfirm {
  display: inline-block;
  width: 50px;
  height: 32px;
  /* background: #0B8586; */
  background: #3c81df;
  border-radius: 3px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
.tipIcon {
  vertical-align: -6px;
  margin-right: 10px;
}
.close {
  cursor: pointer;
  width: 10px;
  height: 10px;
}
</style>
